var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10.199,
    y: 58.122,
    style: {
      fill: "#FFE6B8"
    },
    width: 491.602,
    height: 322.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200.241,
    y: 380.706,
    style: {
      fill: "#CCCCCC"
    },
    width: 111.508,
    height: 73.169
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "271.038,286.309 325.703,269.765 287.582,231.643  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 338.675,
    y: 108.325,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 242.6668 -202.3828)",
    style: {
      fill: "#FFAD61"
    },
    width: 53.911,
    height: 166.817
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35B38"
    },
    d: "M458.05,137.418c5.429-5.429,5.429-14.231,0-19.66l-18.462-18.462c-5.429-5.429-14.231-5.429-19.66,0 l-14.386,14.386l38.123,38.122L458.05,137.418z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.75,
    y: 102.38,
    style: {
      fill: "#BCC987"
    },
    width: 182.913,
    height: 131.814
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M358.135,464.077c5.633,0,10.199-4.566,10.199-10.199s-4.566-10.199-10.199-10.199h-36.179v-52.775 h179.845c5.633,0,10.199-4.566,10.199-10.199V58.122c0-5.633-4.566-10.199-10.199-10.199H10.199C4.566,47.923,0,52.489,0,58.122 v322.581c0,5.633,4.566,10.199,10.199,10.199h179.845v52.775h-36.179c-5.633,0-10.199,4.566-10.199,10.199 c0,5.633,4.566,10.199,10.199,10.199h204.27V464.077z M301.558,443.679h-91.116v-52.775h91.116V443.679z M20.398,370.505V68.321 h471.203v302.183H20.398V370.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M55.75,244.394h182.909c5.633,0,10.199-4.566,10.199-10.199V102.378 c0-5.633-4.566-10.199-10.199-10.199H55.75c-5.633,0-10.199,4.566-10.199,10.199v131.818 C45.551,239.828,50.117,244.394,55.75,244.394z M145.673,223.996H80.847l32.413-32.413L145.673,223.996z M174.395,223.996 c-0.261-0.337-0.537-0.664-0.847-0.973l-17.522-17.522l39.683-39.683l32.751,32.751v25.429h-54.065V223.996z M228.46,112.577 v57.143l-25.54-25.539c-3.983-3.983-10.441-3.982-14.424,0l-46.895,46.895l-21.13-21.13c-3.983-3.983-10.441-3.983-14.425,0 l-40.099,40.099v-97.469C65.948,112.577,228.46,112.577,228.46,112.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M465.262,144.631c4.552-4.552,7.059-10.605,7.059-17.042c0-6.439-2.507-12.491-7.059-17.042 l-18.462-18.463c-9.398-9.397-24.687-9.396-34.084,0L280.37,224.431c-1.231,1.231-2.079,2.699-2.549,4.257l-0.001,0.001 l-0.002,0.008c-0.008,0.025-0.015,0.051-0.023,0.076L263.47,276.11H55.75c-5.633,0-10.199,4.566-10.199,10.199 s4.566,10.199,10.199,10.199h215.28c0.003,0,0.007,0,0.01,0c0.002,0,0.004,0,0.007,0h0.312c1.496,0,2.913-0.33,4.193-0.909 l53.106-16.072l0.001-0.001c1.593-0.482,3.059-1.351,4.256-2.549L465.262,144.631z M286.319,271.029l6.092-20.131l14.039,14.039 L286.319,271.029z M419.968,113.681l7.174-7.173c1.443-1.444,3.793-1.444,5.236,0l18.462,18.463 c0.943,0.943,1.084,2.045,1.084,2.618s-0.141,1.675-1.084,2.618l-7.174,7.173L419.968,113.681z M302.006,231.643l103.538-103.538 l23.698,23.698L325.703,255.341L302.006,231.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M55.75,345.556h356.298c5.633,0,10.199-4.566,10.199-10.199s-4.566-10.199-10.199-10.199H55.75 c-5.633,0-10.199,4.566-10.199,10.199S50.117,345.556,55.75,345.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D3D36"
    },
    d: "M457.333,325.158h-5.509c-5.633,0-10.199,4.566-10.199,10.199s4.566,10.199,10.199,10.199h5.509 c5.633,0,10.199-4.566,10.199-10.199S462.966,325.158,457.333,325.158z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon5);
export default __webpack_public_path__ + "static/media/nav-icon5.d5c60bc93b289e954b0775da3c4115db.svg";
export { ForwardRef as ReactComponent };